import { call, put, takeLatest, takeLeading } from 'redux-saga/effects';
import { platformServicesMasterActions } from '../reducers/platform-master';
import platformServicesMasterService from '../api/platformServicesMasterService';

function* platformServicesMasterDataRequest({ payload }: any): any {
  const res = yield call(platformServicesMasterService.fetchServices, payload);
  if (res.status === 'success') {
    yield put(platformServicesMasterActions.getServicesDataResponse(res));
  } else {
    yield put(platformServicesMasterActions.getServicesDataFailed(res?.code));
  }
}

function* addPlatformServiceMaster({ payload }: any): any {
  const res = yield call(platformServicesMasterService.addService, payload);
  if (res.status === 'success') {
    yield put(platformServicesMasterActions.addServiceResponse(res?.code));
  } else {
    yield put(platformServicesMasterActions.addServiceFailed(res?.code));
  }
}

function* updatePlatformServiceMaster({ payload }: any): any {
  const res = yield call(platformServicesMasterService.updateService, payload);
  if (res.status === 'success') {
    yield put(platformServicesMasterActions.updateServiceResponse(res?.code));
  } else {
    yield put(platformServicesMasterActions.updateServiceFailed(res?.code));
  }
}

function* removePlatformServiceMaster({ payload }: any): any {
  const res = yield call(platformServicesMasterService.removeService, payload);
  if (res.status === 'success') {
    yield put(platformServicesMasterActions.removeServiceResponse(res?.code));
  } else {
    yield put(platformServicesMasterActions.removeServiceFailed(res?.code));
  }
}

function* platformServicesMasterSaga() {
  yield takeLatest('platformServicesMaster/getServicesDataRequest', platformServicesMasterDataRequest);
  yield takeLeading('platformServicesMaster/addServiceRequest', addPlatformServiceMaster);
  yield takeLeading('platformServicesMaster/removeServiceRequest', removePlatformServiceMaster);
  yield takeLeading('platformServicesMaster/updateServiceRequest', updatePlatformServiceMaster);
}

export default platformServicesMasterSaga;
